$mol_theme_auto $mol_plugin
	attr * mol_theme <= theme \
